module.exports = __webpack_public_path__ + "img/je.6ab08614.svg";